import {
  stats,
  panchayats,
  problems,
  stories,
  whyDrone,
  dskSupport,
  earnWays,
  whoCanApply,
  eligibility,
  steps,
  villageStoriesHeader,
  villageStories,
  droneSprayOpportunity,
} from "../../data/dskData";
import { useState, useRef, useEffect } from "react";

import modal1 from "../../assets/image/dsk/modal1.png";
import modal2 from "../../assets/image/dsk/modal2.png";
import rog1 from "../../assets/image/dsk/rog1.webp";
import rog2 from "../../assets/image/dsk/rog2.webp";
import rog3 from "../../assets/image/dsk/rog3.webp";
import rog4 from "../../assets/image/dsk/rog4.webp";
import rog5 from "../../assets/image/dsk/rog5.webp";
import rog6 from "../../assets/image/dsk/rog6.webp";
import lightgreen from "../../assets/image/dsk/light-green.webp";
import partnering from "../../assets/image/dsk/what dsk.webp";
import farmerfield from "../../assets/image/dsk/Entrepreneur.png";
import faqImg from "../../assets/image/dsk/faq.webp";
import thumbnail1 from "../../assets/image/dsk/video-thumb-1.webp";
import thumbnail2 from "../../assets/image/dsk/video-thumb-2.webp";

const realityData = [
  {
    id: 1,
    image: rog1,
    icon: (
      <svg className="w-4 h-4 text-[#3f674d] fill-current" viewBox="0 0 24 24">
        <path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM12 20c-3.35 0-6-2.57-6-6.2 0-2.34 1.95-5.44 6-9.14 4.05 3.7 6 6.79 6 9.14 0 3.63-2.65 6.2-6 6.2z" />
        <path
          d="M3.5 3.5l17 17-1.41 1.41-17-17z"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
    title: { en: "Water Scarcity", hi: "पानी की कमी" },
    desc: {
      en: "Villagers spending hours daily queuing for a single water pump, severely limiting agricultural productivity.",
      hi: "ग्रामीणों को पानी के लिए घंटों कतार में लगना पड़ता है, जिससे कृषि उत्पादकता बुरी तरह प्रभावित होती है।",
    },
  },
  {
    id: 3,
    image: rog3,
    icon: (
      <svg className="w-4 h-4 text-[#3f674d] fill-current" viewBox="0 0 24 24">
        <path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z" />
      </svg>
    ),
    title: { en: "Pest Infestations", hi: "कीटों का प्रकोप" },
    desc: {
      en: "Locust swarms and new diseases wiping out entire harvest cycles in a matter of days.",
      hi: "टिड्डियों के दल और नई बीमारियाँ कुछ ही दिनों में पूरी फसल को नष्ट कर देती हैं।",
    },
  },
  {
    id: 4,
    image: rog4,
    icon: (
      <svg className="w-4 h-4 text-[#3f674d] fill-current" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
      </svg>
    ),
    title: { en: "Economic Hardship", hi: "आर्थिक संकट" },
    desc: {
      en: "Mounting debts, lack of fair market access, and unpredictable yields leading to severe psychological and financial stress.",
      hi: "बढ़ता कर्ज, बाजार तक पहुंच की कमी और अनिश्चित पैदावार गंभीर मनोवैज्ञानिक और वित्तीय तनाव का कारण बन रही है।",
    },
  },
  {
    id: 5,
    image: rog5,
    icon: (
      <svg className="w-4 h-4 text-[#3f674d] fill-current" viewBox="0 0 24 24">
        <path d="M12 3c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L12 22l7.03-4.39C20.26 16.07 21 14.12 21 12c0-4.97-4.03-9-9-9zm0 16.5l-5.46-3.41C5.57 14.89 5 13.51 5 12c0-3.86 3.14-7 7-7s7 3.14 7 7c0 1.51-.57 2.89-1.54 4.09L12 19.5z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
    title: { en: "Soil Degradation", hi: "मिट्टी का क्षरण" },
    desc: {
      en: "Over-farming and chemical fertilizers leading to nutrient-depleted soils and wilted crops.",
      hi: "अत्यधिक खेती और रासायनिक उर्वरकों के कारण मिट्टी के पोषक तत्व खत्म हो रहे हैं।",
    },
  },
  {
    id: 6,
    image: rog6,
    icon: (
      <svg className="w-4 h-4 text-[#3f674d] fill-current" viewBox="0 0 24 24">
        <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 2.39.84 4.58 2.23 6.31L12 24l7.77-5.69C21.16 16.58 22 14.39 22 12zm-10 9.25l-5.66-4.14C5.19 15.65 4 13.96 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.96-1.19 3.65-2.34 5.11L12 21.25z" />
        <path d="M12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
      </svg>
    ),
    title: { en: "Severe Flooding", hi: "भयंकर बाढ़" },
    desc: {
      en: "Unseasonal, heavy monsoons submerging fields, destroying homes, and washing away topsoil.",
      hi: "बेमौसम और भारी बारिश के कारण खेत डूब जाते हैं, घर नष्ट हो जाते हैं और उपजाऊ मिट्टी बह जाती है।",
    },
  },
];


const videoStories = [
  {
    id: 1,
    youtubeId: "ChBbQeIDBKk",
    thumbnail: thumbnail1,
    name: { en: "Rajesh Kumar", hi: "राजेश कुमार" },
    location: { en: "Punjab", hi: "पंजाब" },
    quote: {
      en: '"The drone technology saved my entire wheat crop from the sudden locust attack this year."',
      hi: '"ड्रोन तकनीक ने इस साल मेरी पूरी गेहूं की फसल को अचानक टिड्डियों के हमले से बचा लिया।"',
    },
    duration: "3:45",
  },
  {
    id: 2,
    youtubeId: "B4n6nyja3-U",
    thumbnail: thumbnail2,
    name: { en: "Sunita Devi", hi: "सुनीता देवी" },
    location: { en: "Maharashtra", hi: "महाराष्ट्र" },
    quote: {
      en: '"We reduced our water usage by half while seeing our sugarcane yield increase."',
      hi: '"हमने गन्ने की पैदावार में वृद्धि देखने के साथ-साथ अपने पानी के उपयोग को आधा कर दिया है।"',
    },
    duration: "4:13",
  },
];

const droneFeatures = [
  {
    id: 1,
    title: { en: "Better Spraying", hi: "अच्छा छिड़काव" },
    desc: {
      en: "Equal quantity reaches every plant.",
      hi: "हर पौधे तक सही मात्रा पहुंचती है।",
    },
    icon: (
      <svg
        className="w-6 h-6 text-[#4ade80] fill-current"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6.5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5z" />
      </svg>
    ),
  },
  {
    id: 2,
    title: { en: "Time Saving", hi: "समय की बचत" },
    desc: {
      en: "Spray more fields in less time.",
      hi: "कम समय में ज्यादा खेतों में छिड़काव।",
    },
    icon: (
      <svg
        className="w-6 h-6 text-[#4ade80]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    id: 3,
    title: { en: "Safe for Farmers", hi: "किसानों के लिए सुरक्षित" },
    desc: {
      en: "Distance from harmful chemicals.",
      hi: "रसायनों से दूरी बनी रहती है।",
    },
    icon: (
      <svg
        className="w-6 h-6 text-[#4ade80]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
        />
      </svg>
    ),
  },
  {
    id: 4,
    title: { en: "Lower Expenses", hi: "खर्च कम" },
    desc: {
      en: "Saves water, time, and labour cost.",
      hi: "पानी, समय और मजदूरी की बचत।",
    },
    icon: (
      <svg
        className="w-6 h-6 text-[#4ade80]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
        />
      </svg>
    ),
  },
];

// Dummy SVG Icons
const Icons = {
  training: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-green-800"
    >
      <path d="M10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      <path d="M2 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3z" />
    </svg>
  ),
  maintenance: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-green-800"
    >
      <path d="M16 11V5.5c0-1.9-1.6-3.5-3.5-3.5h-5C5.6 2 4 3.6 4 5.5V11m12 0a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1M4 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1" />
      <path d="M7 14.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
      <path d="M13 14.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
    </svg>
  ),
  agronomy: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-green-800"
    >
      <path d="M2 18s1-1 1-3.5V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8.5c0 2.5 1 3.5 1 3.5" />
      <path d="M8 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      <path d="M12 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      <path d="M10 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
    </svg>
  ),
  rate: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-gray-100"
    >
      <path d="M15 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-10 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5-5s1-1 1-2" />
      <path d="M4.5 15h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z" />
    </svg>
  ),
  coverage: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-gray-100"
    >
      <path d="M2 18h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" />
      <path d="M10 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
      <path d="M10 17.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
    </svg>
  ),
  revenue: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-gray-100"
    >
      <path d="M4 14l3.5-3.5L10 13l6-6" />
      <path d="M10 3h7v7" />
    </svg>
  ),
  profit: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-gray-100"
    >
      <path d="M12 11c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3z" />
      <path d="M17 19H7a4.996 4.996 0 0 1-4.89-6C2.39 12.18 3.56 11 5 11s2.61 1.18 2.89 2c.32 1.32.74 1.83 1.37 2.37A6.974 6.974 0 0 0 12 17a6.974 6.974 0 0 0 4.74-1.63c.63-.54 1.05-1.05 1.37-2.37.28-.82.93-2 2.89-2 1.44 0 2.61 1.18 2.89 2A4.996 4.996 0 0 1 17 19z" />
    </svg>
  ),
};

const applicantTypes = [
  {
    id: 1,
    title: { en: 'Village Youth', hi: 'गांव के युवा' },
    desc: {
      en: 'Young individuals from rural areas looking to start a modern business and stay in their village.',
      hi: 'ग्रामीण क्षेत्रों के युवा जो आधुनिक व्यवसाय शुरू करना चाहते हैं और अपने गांव में रहना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    )
  },
  {
    id: 2,
    title: { en: 'Farmers', hi: 'किसान' },
    desc: {
      en: 'Farmers who want to modernize their own farming and also provide services to other fields.',
      hi: 'किसान जो अपनी खेती को आधुनिक बनाना चाहते हैं और दूसरों के खेतों में भी सेवाएं देना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 21v-4m0 0a5 5 0 015-5h1a5 5 0 005-5V3m-6 18h12M12 9a5 5 0 015 5h1a5 5 0 015 5v2M12 9c0-3-2-5-5-5" />
      </svg>
    )
  },
  {
    id: 3,
    title: { en: 'PACS Members', hi: 'पैक्स सदस्य' },
    desc: {
      en: 'Primary Agricultural Credit Society members who want to add drone services to their portfolio.',
      hi: 'प्राथमिक कृषि ऋण समिति (PACS) के सदस्य जो अपने कार्यों में ड्रोन सेवाएं जोड़ना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    )
  },
  {
    id: 4,
    title: { en: 'CSC Operators', hi: 'जन सेवा केंद्र संचालक' },
    desc: {
      en: 'Common Service Center operators looking to expand their offerings with agricultural drone technology.',
      hi: 'जन सेवा केंद्र (CSC) संचालक जो कृषि ड्रोन तकनीक के साथ अपनी सेवाओं का विस्तार करना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    )
  },
  {
    id: 5,
    title: { en: 'Self Help Group Members', hi: 'स्वयं सहायता समूह सदस्य' },
    desc: {
      en: 'Members of SHGs aiming to generate collective income through new agricultural technologies.',
      hi: 'स्वयं सहायता समूहों (SHG) के सदस्य जो नई कृषि तकनीकों के माध्यम से सामूहिक आय उत्पन्न करना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    )
  },
  {
    id: 6,
    title: { en: 'Agriculture Shop Owners', hi: 'कृषि दुकान मालिक' },
    desc: {
      en: 'Owners of pesticide or seed shops who can provide spraying services directly to their customers.',
      hi: 'कीटनाशक या बीज की दुकानों के मालिक जो अपने ग्राहकों को सीधे छिड़काव सेवाएं प्रदान कर सकते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>
    )
  },
  {
    id: 7,
    title: { en: 'Tractor Owners', hi: 'ट्रैक्टर मालिक' },
    desc: {
      en: 'Individuals already providing tractor rental services who want to add drone spraying.',
      hi: 'जो लोग पहले से ही ट्रैक्टर किराए पर देने की सेवाएं दे रहे हैं और ड्रोन छिड़काव जोड़ना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="7" cy="17" r="2" strokeWidth="1.5" />
        <circle cx="17" cy="17" r="2" strokeWidth="1.5" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 17H3v-4l2-2h4l4 2h4v4h-2M13 11v-4h4l3 3v2" />
      </svg>
    )
  },
  {
    id: 8,
    title: { hi: 'महिलाएं' },
    desc: {
      hi: 'कृषि क्षेत्र में स्वतंत्र कमाई के अवसर और सशक्तिकरण की तलाश कर रही महिलाएं (नमो ड्रोन दीदी)।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    )
  },
  {
    id: 9,
    title: { en: 'Students', hi: 'विद्यार्थी' },
    desc: {
      en: 'Students who want to learn future-ready skills and start a part-time or full-time business.',
      hi: 'छात्र जो भविष्य की तकनीक सीखना चाहते हैं और पार्ट-टाइम या फुल-टाइम व्यवसाय शुरू करना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
      </svg>
    )
  },
  {
    id: 10,
    title: { en: 'Unemployed Youth', hi: 'बेरोजगार युवा' },
    desc: {
      en: 'Youth seeking a stable and highly profitable self-employment opportunity in their own village.',
      hi: 'युवा जो अपने ही गांव में एक स्थिर और अत्यधिक लाभदायक स्वरोजगार के अवसर की तलाश में हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    )
  },
  {
    id: 11,
    title: { hi: 'एफीओ' },
    desc: {
      hi: 'किसान उत्पादक संगठन जो अपने सभी सदस्यों को किफायती ड्रोन सेवाएं प्रदान करना चाहते हैं।'
    },
    icon: (
      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    )
  }
];

const requirements = [
  {
    id: 1,
    icon: (<svg className="w-5 h-5 text-[#059669]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" /></svg>),
    label: { en: "EDUCATION", hi: "शैक्षिक योग्यता" },
    title: { en: "Minimum 10th pass", hi: "कम से कम 10वीं पास" },
    desc: { en: "Minimum basic education required.", hi: "न्यूनतम बुनियादी शिक्षा आवश्यक है।" },
  },
  {
    id: 2,
    icon: (<svg className="w-5 h-5 text-[#059669]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>),
    label: { en: "AGE LIMIT", hi: "आयु सीमा" },
    title: { en: "21–35 years", hi: "21–35 साल" },
    desc: { en: "Applicant must be within the specified age bracket.", hi: "आवेदक निर्दिष्ट आयु सीमा के भीतर होना चाहिए।" },
  },
  {
    id: 3,
    icon: (<svg className="w-5 h-5 text-[#059669]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>),
    label: { en: "RESIDENCE", hi: "निवास स्थान" },
    title: { en: "Village or small town", hi: "गांव या छोटे कस्बे में रहने वाले" },
    desc: { en: "Must be a resident of a village or small town.", hi: "गांव या छोटे कस्बे का निवासी होना चाहिए।" },
  },
  {
    id: 4,
    icon: (<svg className="w-5 h-5 text-[#059669]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>),
    label: { en: "FINANCIAL", hi: "वित्तीय योग्यता" },
    title: { en: "Eligible for loan", hi: "ऋण लेने की योग्यता" },
    desc: { en: "Must be eligible to receive a business loan.", hi: "व्यवसाय ऋण प्राप्त करने के योग्य होना चाहिए।" },
  }
];

const applicationSteps = [
  { num: 1, title: { hi: "आवेदन करें", en: "Apply" }, desc: { hi: "अपनी सामान्य जानकारी भरें।", en: "Fill in your basic information." } },
  { num: 2, title: { hi: "जानकारी और बातचीत", en: "Information and Discussion" }, desc: { hi: "व्हाट्सऐप पर कुछ सवाल पूछे जाएंगे।", en: "Some questions will be asked on WhatsApp." } },
  { num: 3, title: { hi: "हमारी टीम संपर्क करेगी", en: "Our Team Will Contact You" }, desc: { hi: "चयन के बाद हमारी टीम आपसे बात करेगी।", en: "After selection, our team will speak with you." } },
  { num: 4, title: { hi: "प्रशिक्षण और ड्रोन पायलट लाइसेंस", en: "Training and Drone Pilot License" }, desc: { hi: "ड्रोन चलाने के लिए फ्रि ट्रेनिंग दी जाएगी।", en: "Free drone training will be provided." } },
  { num: 5, title: { hi: "काम शुरू करें", en: "Start Working" }, desc: { hi: "अपने गांव में ड्रोन सेवाएं शुरू करें और लाखों कमाएं।", en: "Start drone services in your village and earn lakhs." } },
].map((s, i) => ({ id: s.num, title: s.title, desc: s.desc }));

const hideScrollbar = `
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const SectionTag = ({ children }) => (
  <span className="inline-block text-[11px] font-bold tracking-[1px] uppercase text-[#3f674d] bg-[#f0f6f2] rounded-full px-4 py-1.5 mb-2">
    {children}
  </span>
);

const SectionHeading = ({ children, center = false }) => (
  <h2
    className={`text-[clamp(26px,4vw,38px)] font-bold text-gray-800 mb-3 tracking-tight leading-[1.2] ${center ? "text-center" : ""
      }`}
  >
    {children}
  </h2>
);

const VillageStoriesSlider = ({ hi }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % villageStories.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const getOffset = (idx) => {
    const len = villageStories.length;
    let offset = (((idx - currentSlide) % len) + len) % len;
    if (offset > Math.floor(len / 2)) {
      offset -= len;
    }
    return offset;
  };

  return (
    <div className="relative w-full min-h-[600px] flex flex-col items-center justify-center overflow-hidden">
      {/* Slider Track with Edge Fading Mask */}
      <div
        className="relative w-full h-[550px] md:h-[600px] flex items-center justify-center mt-4"
        style={{
          maskImage: 'linear-gradient(to right, transparent 0%, black 15%, black 85%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 15%, black 85%, transparent 100%)'
        }}
      >
        {villageStories.map((story, idx) => {
          const offset = getOffset(idx);
          // Scale down the translate value on mobile so cards fit on screen
          const translateX = offset * (window.innerWidth < 768 ? 270 : 400);
          const scale = offset === 0 ? 1 : 0.8;
          const opacity = offset === 0 ? 1 : 0.5;
          const zIndex = offset === 0 ? 10 : 5 - Math.abs(offset);

          return (
            <div
              key={idx}
              className="absolute w-[320px] md:w-[400px] bg-white rounded-3xl shadow-[0_12px_40px_-12px_rgba(0,0,0,0.15)] transition-all duration-500 ease-out border border-gray-100 overflow-hidden flex flex-col"
              style={{
                transform: `translateX(${translateX}px) scale(${scale})`,
                opacity,
                zIndex,
              }}
            >
              {/* Card Header */}
              <div className="bg-gradient-to-r from-[#3f674d] to-[#2d4a37] flex items-center px-4 md:px-5 py-3 md:py-3.5 gap-3">
                <div className="rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 w-8 h-8 md:w-9 md:h-9">
                  <svg className="text-white w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={story.iconPath} />
                  </svg>
                </div>
                <h3 className="font-bold text-white leading-tight text-[15px] md:text-[17px]">
                  {hi ? story.title.hi : story.title.en}
                </h3>
              </div>

              {/* Content Split (Top/Bottom) */}
              <div className="flex flex-col flex-1 overflow-hidden">
                {/* Earlier */}
                <div className="flex flex-col flex-1 border-b border-gray-100 bg-red-50/30 px-4 md:px-5 pt-4 md:pt-5 pb-0">
                  <div className="flex items-center mb-2 md:mb-3 gap-2">
                    <span className="rounded-full bg-red-400 flex-shrink-0 w-2.5 h-2.5" />
                    <span className="font-bold uppercase tracking-wider text-red-500 text-[10.5px] md:text-[11.5px]">
                      {hi ? "पहले" : "Earlier"}
                    </span>
                  </div>
                  <ul className="flex flex-col m-0 p-0 list-none gap-2">
                    {(hi ? story.earlier.hi : story.earlier.en).map((point, i) => (
                      <li key={i} className="text-gray-600 pl-4 relative text-[12.5px] md:text-[13.5px] leading-snug">
                        <span className="absolute left-0 rounded-full bg-red-300 top-[6px] md:top-[7px] w-1.5 h-1.5" />
                        {point}
                      </li>
                    ))}
                  </ul>

                  {/* Image Placeholder utilizing empty space */}
                  <div className="mt-auto flex justify-center pt-4 pb-2 z-10 px-4">
                    <div className="w-[260px] sm:w-[320px] h-[120px] sm:h-[140px] bg-white rounded-2xl border-[5px] border-gray-50 shadow-md overflow-hidden flex items-center justify-center relative">
                      <div className="absolute inset-0 bg-gray-100" />
                      {story.imgSrc ? (
                        <img
                          src={story.imgSrc}
                          alt={hi ? story.title.hi : story.title.en}
                          className="w-full h-full object-cover relative z-10"
                        />
                      ) : (
                        <svg className="w-10 h-10 text-gray-300 relative z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      )}
                    </div>
                  </div>
                </div>

                {/* Today */}
                <div className="bg-emerald-50/40 flex flex-col justify-center px-4 md:px-5 py-3 md:py-4 h-[110px] md:h-[120px] shrink-0">
                  <div className="flex items-center mb-2 gap-2">
                    <span className="rounded-full bg-emerald-500 flex-shrink-0 w-2.5 h-2.5" />
                    <span className="font-bold uppercase tracking-wider text-emerald-600 text-[10.5px] md:text-[11.5px]">
                      {hi ? "आज" : "Today"}
                    </span>
                  </div>
                  <div className="bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2 md:px-4 md:py-3 h-full flex items-center">
                    <p className="text-emerald-800 font-semibold m-0 text-[12.5px] md:text-[13.5px] leading-snug w-full">
                      {hi ? story.today.hi : story.today.en}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-2 md:mt-4 z-20">
        {villageStories.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentSlide ? "bg-[#3f674d] w-6" : "bg-gray-300"
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default function MainSections({ lang }) {
  const [playingVideo, setPlayingVideo] = useState(null);
  const hi = lang === "hi";
  const scrollRef = useRef(null);
  const villageStoriesRef = useRef(null);

  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % applicationSteps.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -440, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 440, behavior: "smooth" });
    }
  };

  const villageScrollLeft = () => {
    if (villageStoriesRef.current) {
      villageStoriesRef.current.scrollBy({ left: -440, behavior: "smooth" });
    }
  };

  const villageScrollRight = () => {
    if (villageStoriesRef.current) {
      villageStoriesRef.current.scrollBy({ left: 440, behavior: "smooth" });
    }
  };

  return (
    <>
      <style>{hideScrollbar}</style>
      {/* WHAT IS DSK */}
      <section
        id="what-dsk"
        className="bg-white -mt-[15px] pt-[24px] pb-[16px] px-5 relative overflow-hidden"
      >
        {/* Increased max-width slightly to accommodate the human models comfortably */}
        <div className="max-w-[1200px] mx-auto relative z-10">
          {/* Centered Header Content */}
          <div className="flex flex-col items-center text-center mb-10 relative z-10">
            <SectionTag>{hi ? "DSK के बारे में" : "About DSK"}</SectionTag>
            <SectionHeading center>
              {hi ? (
                <>
                  ड्रोन सुविधा केंद्र{" "}
                  <span className="text-[#3f674d]">क्या है?</span>
                </>
              ) : (
                <>
                  What is{" "}
                  <span className="text-[#3f674d]">
                    Drone Suvidha Kendra ?
                  </span>
                </>
              )}
            </SectionHeading>
            <p className="text-[15px] text-gray-500 max-w-[700px] mx-auto leading-relaxed mt-0">
              {hi
                ? "DSK एक ग्रामीण ड्रोन उद्यमिता कार्यक्रम है, जिसका उद्देश्य गांवों में ड्रोन स्प्रे सर्विस शुरू करके युवाओं को नई तकनीक आधारित कमाई का अवसर देना है।"
                : "DSK (Drone Suvidha Kendra) is a rural drone entrepreneurship program, created to provide youth with a new technology-based earning opportunity by starting drone spray services in villages."}
            </p>
          </div>

          {/* Main Green Banner (Left-Right Split Design) */}
          <div className="max-w-[1000px] mx-auto bg-[#064e3b] rounded-[24px] px-8 py-10 shadow-xl relative z-10 mb-8 overflow-hidden flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>
            <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>

            {/* Left Side: Title */}
            <div className="relative z-10 w-full md:w-[40%] text-center md:text-left border-b md:border-b-0 md:border-r border-white/10 pb-8 md:pb-0 md:pr-8">
              <h3 className="text-[32px] md:text-[42px] font-extrabold text-white tracking-tight leading-tight">
                {hi ? "1 पंचायत" : "1 Panchayat"}<br />
                <span className="text-emerald-400">{hi ? "1 ड्रोन मिशन" : "1 Drone Mission"}</span>
              </h3>
              <p className="text-emerald-100/80 mt-4 text-[15px] font-medium leading-relaxed max-w-[280px] mx-auto md:mx-0">
                {hi ? "ग्रामीण भारत में ड्रोन के माध्यम से नए उद्यमी तैयार करना।" : "Empowering rural India by creating new drone entrepreneurs."}
              </p>
            </div>

            {/* Right Side: 2x2 Grid */}
            <div className="relative z-10 w-full md:w-[60%] grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                {
                  en: { num: "₹4.94L Cr+", label: "Market Opportunity" },
                  hi: { num: "₹4.94L करोड़+", label: "का मार्केट" },
                  colorClass: "bg-emerald-50 hover:bg-emerald-100 border-emerald-200 text-emerald-800",
                  numColor: "text-emerald-950"
                },
                {
                  en: { num: "₹1 Lakh+", label: "Earn Per Month" },
                  hi: { num: "₹1 लाख+", label: "हर महीने कमाई" },
                  colorClass: "bg-teal-50 hover:bg-teal-100 border-teal-200 text-teal-800",
                  numColor: "text-teal-950"
                },
                {
                  en: { num: "Up to 90%", label: "Loan Assistance" },
                  hi: { num: "90% तक", label: "लोन सहायता" },
                  colorClass: "bg-green-50 hover:bg-green-100 border-green-200 text-green-800",
                  numColor: "text-green-950"
                },
                {
                  en: { num: "30 Lakh", label: "Entrepreneurs Target" },
                  hi: { num: "30 लाख", label: "उद्यमियों का लक्ष्य" },
                  colorClass: "bg-lime-50 hover:bg-lime-100 border-lime-200 text-lime-800",
                  numColor: "text-lime-950"
                },
              ].map((item, idx) => (
                <div key={idx} className={`${item.colorClass} border rounded-xl px-4 py-3 md:px-5 md:py-4 flex flex-col justify-center transition-all duration-300 shadow-sm`}>
                  <h4 className={`text-[22px] md:text-[24px] font-extrabold leading-tight mb-0.5 tracking-tight ${item.numColor}`}>
                    {hi ? item.hi.num : item.en.num}
                  </h4>
                  <p className="text-[13.5px] font-medium leading-snug">
                    {hi ? item.hi.label : item.en.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="relative w-full bg-gradient-to-b from-[#f2f8f4] to-[#ebf3ed] py-[24px] overflow-hidden mb-[16px]">
        {/* Background Image with Bottom Fade (Replace src with your actual landscape export) */}
        <div
          className="absolute bottom-0 left-0 w-full h-[350px] pointer-events-none z-0"
          style={{
            backgroundImage: `url('${lightgreen}')`,
            backgroundPosition: "center bottom",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            maskImage: "linear-gradient(to bottom, transparent 0%, black 100%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, transparent 0%, black 100%)",
            opacity: 0.8,
          }}
        />

        <div className="relative z-10 max-w-[1536px] mx-auto px-4 w-full flex flex-col items-center">
          {/* Optional Section Header matching the design */}
          {/* <h2 className="text-[28px] md:text-[34px] text-[#2d3748] mb-2 text-center tracking-tight">
            {hi ? (
              <>
                <span className="font-extrabold text-[#1a202c]">
                  लाइट ग्रीन
                </span>{" "}
                थीम कार्ड लेआउट
              </>
            ) : (
              <>
                <span className="font-extrabold text-[#1a202c]">
                  Light green
                </span>{" "}
                themed card layout
              </>
            )}
          </h2> */}
          {/* <p className="text-[16px] md:text-[18px] text-[#4a5568] mb-12 text-center font-medium">
            {hi
              ? "गोलाकार आइकन और कंटेंट के साथ"
              : "with circular icons and content"}
          </p> */}

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5 w-full mb-12">
            {stats.map((s, i) => {
              const pillClasses = [
                "bg-emerald-100 text-emerald-950",
                "bg-teal-100 text-teal-950",
                "bg-green-100 text-green-950",
                "bg-lime-100 text-lime-950",
                "bg-emerald-100 text-emerald-950",
              ];

              const getIcon = (index) => {
                const iconClass = "w-7 h-7 text-gray-800 stroke-current fill-none stroke-[2] stroke-linecap-round stroke-linejoin-round";
                switch (index) {
                  case 0: // Panchayats
                    return (
                      <svg className={iconClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    );
                  case 1: // Market
                    return (
                      <svg className={iconClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                        <polyline points="17 6 23 6 23 12"></polyline>
                      </svg>
                    );
                  case 2: // Income
                    return (
                      <svg className={iconClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
                        <line x1="2" y1="10" x2="22" y2="10"></line>
                      </svg>
                    );
                  case 3: // Loan
                    return (
                      <svg className={iconClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <line x1="19" y1="5" x2="5" y2="19"></line>
                        <circle cx="6.5" cy="6.5" r="2.5"></circle>
                        <circle cx="17.5" cy="17.5" r="2.5"></circle>
                      </svg>
                    );
                  case 4: // Target
                    return (
                      <svg className={iconClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10"></circle>
                        <circle cx="12" cy="12" r="6"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                      </svg>
                    );
                  default:
                    return null;
                }
              };

              return (
                <div
                  key={i}
                  className="bg-white rounded-[24px] px-4 pt-4 pb-2.5 md:px-5 md:pt-5 md:pb-3 flex flex-col items-center justify-center text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 min-h-[140px]"
                >
                  {/* Outline Icon Container */}
                  <div className="mb-3 md:mb-4">
                    {getIcon(i)}
                  </div>

                  {/* Colored Pill for the Number */}
                  <div className={`${pillClasses[i]} px-3 py-1.5 md:px-4 md:py-2 rounded-full mb-4 whitespace-nowrap`}>
                    <div className="text-[14px] md:text-[15px] font-extrabold leading-tight tracking-tight">
                      {hi ? s.num.hi : s.num.en}
                    </div>
                  </div>

                  {/* Text Label */}
                  <div className="text-[13.5px] md:text-[14.5px] text-gray-700 font-bold tracking-wide leading-snug text-balance">
                    {hi ? s.lbl.hi : s.lbl.en}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Action Button */}
          {/* <button
            onClick={() =>
              document.getElementById("form")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
            className="bg-[#385e43] hover:bg-[#2d4e36] text-white px-9 py-3.5 rounded-lg font-semibold text-[15px] shadow-lg shadow-green-900/20 transition-all duration-300"
          >
            {hi ? "अपनी जगह सुरक्षित करें" : "Secure your place"}
          </button> */}
        </div>
      </section>

      {/* Reality on the Ground */}
      <section className="bg-white py-[12px] px-5">
        <div className="max-w-[1200px] mx-auto">
          {/* Section Header */}
          <div className="text-center mb-8 flex flex-col items-center">
            <h2 className="text-[32px] md:text-[38px] font-bold text-[#111827] tracking-tight mb-2">
              {hi ? "गांव की असली समस्या" : "The Real Problems of Villages"}
            </h2>
            <p className="text-[15px] md:text-[16px] text-[#4b5563] max-w-[700px] leading-relaxed">
              {hi
                ? "मेहनत बढ़ रही है, लेकिन कमाई नहीं। आज गांव की सबसे बड़ी समस्या है, काम और अवसरों की कमी।"
                : "Hard work is increasing, but income is not. Today the biggest problem in villages is lack of work and opportunities."}
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            {problems.map((item, idx) => {
              const images = [rog1, rog2, rog3, faqImg, lightgreen, rog4];
              return (
                <div
                  key={idx}
                  className="flex flex-col group bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-300"
                >
                  {/* Card Image Wrapper */}
                  <div className="w-full h-[220px] relative overflow-hidden bg-gray-100 shrink-0">
                    <img
                      src={item.imgSrc || images[idx]}
                      alt={hi ? item.title.hi : item.title.en}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />

                    {/* Floating Icon Container */}
                    <div className="absolute top-4 right-4 w-[34px] h-[34px] rounded-full bg-white shadow-md flex items-center justify-center flex-shrink-0 z-10">
                      <svg className="w-4 h-4 text-[#3f674d] fill-current" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                      </svg>
                    </div>
                  </div>

                  {/* Content - Problem & Solution side by side */}
                  <div className="flex flex-col sm:flex-row flex-1">
                    {/* Problem Side */}
                    <div className="p-5 sm:w-1/2 border-b sm:border-b-0 sm:border-r border-gray-100 flex flex-col">
                      <div className="text-[12px] font-bold text-red-500 mb-2 uppercase tracking-wide flex items-center gap-1.5">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                        {hi ? "समस्या" : "The Problem"}
                      </div>
                      <h3 className="text-[17px] font-bold text-[#111827] mb-2 leading-snug">
                        {hi ? item.title.hi : item.title.en}
                      </h3>
                      <p className="text-[14px] text-[#6b7280] leading-relaxed mb-auto">
                        {hi ? item.body.hi : item.body.en}
                      </p>
                    </div>

                    {/* Solution Side */}
                    <div className="p-5 sm:w-1/2 bg-green-50/40 flex flex-col justify-center">
                      {item.example && (
                        <div className="mb-4">
                          <p className="text-[14px] text-[#065f46] mt-1 leading-snug font-bold">
                            {hi ? item.example.hi : item.example.en}
                          </p>
                        </div>
                      )}
                      <div>
                        <div className="text-[12px] font-bold text-green-700 mb-2 uppercase tracking-wide flex items-center gap-1.5">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                          {hi ? "DSK समाधान" : "DSK Solution"}
                        </div>
                        <p className="text-[14px] text-[#064e3b] font-medium leading-snug">
                          {hi ? item.solution.hi : item.solution.en}
                        </p>
                      </div>

                    </div>

                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* ========================================== */}
      {/* VILLAGE PEOPLE STORIES                     */}
      {/* ========================================== */}
      <section className="bg-[#f9fafb] py-[40px] px-5 border-t border-gray-100">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-0 relative z-10">
            <div className="max-w-[600px] mx-auto">
              <SectionTag>{hi ? villageStoriesHeader.tag.hi : villageStoriesHeader.tag.en}</SectionTag>
              <h2 className="text-[28px] md:text-[34px] font-bold text-[#111827] tracking-tight mb-3">
                {hi ? (
                  <>
                    {villageStoriesHeader.title.hi.part1}{" "}
                    <span className="text-[#3f674d]">{villageStoriesHeader.title.hi.part2}</span>
                  </>
                ) : (
                  <>
                    {villageStoriesHeader.title.en.part1}{" "}
                    <span className="text-[#3f674d]">{villageStoriesHeader.title.en.part2}</span>
                  </>
                )}
              </h2>
              <p className="text-[14px] md:text-[15px] text-[#4b5563] leading-relaxed">
                {hi ? villageStoriesHeader.subtitle.hi : villageStoriesHeader.subtitle.en}
              </p>
            </div>
          </div>

          <div className="w-full -mt-16 relative z-0">
            <VillageStoriesSlider hi={hi} />
          </div>
        </div>
      </section>

      {/* ========================================== */}
      {/* DRONE SPRAY SERVICES — NEW OPPORTUNITY     */}
      {/* ========================================== */}
      <section className="bg-white py-[40px] px-5">
        <div className="max-w-[1200px] mx-auto">
          {/* Section Header */}
          <div className="text-center mb-10">
            <SectionTag>{hi ? droneSprayOpportunity.header.tag.hi : droneSprayOpportunity.header.tag.en}</SectionTag>
            <h2 className="text-[28px] md:text-[34px] font-bold text-[#111827] tracking-tight mb-3">
              {hi ? (
                <>
                  {droneSprayOpportunity.header.title.hi.part1}{" "}
                  <span className="text-[#3f674d]">{droneSprayOpportunity.header.title.hi.part2}</span>
                </>
              ) : (
                <>
                  {droneSprayOpportunity.header.title.en.part1}{" "}
                  <span className="text-[#3f674d]">{droneSprayOpportunity.header.title.en.part2}</span>
                </>
              )}
            </h2>
            <p className="text-[15px] text-gray-500 max-w-[500px] mx-auto leading-relaxed italic">
              {hi ? droneSprayOpportunity.header.subtitle.hi : droneSprayOpportunity.header.subtitle.en}
            </p>
          </div>

          {/* Two Cards Side by Side */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Card 1 — Opportunity */}
            <div className="bg-gradient-to-br from-[#f0fdf4] to-[#ecfdf5] border border-emerald-200 rounded-2xl p-7 shadow-[0_2px_10px_rgb(0,0,0,0.02)]">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-emerald-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-[17px] font-bold text-gray-900">
                  {hi ? droneSprayOpportunity.opportunity.title.hi : droneSprayOpportunity.opportunity.title.en}
                </h3>
              </div>
              <ul className="flex flex-col gap-3.5 m-0 p-0 list-none">
                {(hi ? droneSprayOpportunity.opportunity.points.hi : droneSprayOpportunity.opportunity.points.en).map((point, i) => (
                  <li key={i} className="text-[14px] text-gray-700 leading-relaxed pl-5 relative font-medium">
                    <span className="absolute left-0 top-[8px] w-2 h-2 rounded-full bg-emerald-400" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>

            {/* Card 2 — Demand */}
            <div className="bg-gradient-to-br from-[#0b2416] to-[#14532d] border border-emerald-800 rounded-2xl p-7 shadow-[0_2px_10px_rgb(0,0,0,0.1)]">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-emerald-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <h3 className="text-[17px] font-bold text-white">
                  {hi ? droneSprayOpportunity.demand.title.hi : droneSprayOpportunity.demand.title.en}
                </h3>
              </div>
              <ul className="flex flex-col gap-3.5 m-0 p-0 list-none">
                {(hi ? droneSprayOpportunity.demand.points.hi : droneSprayOpportunity.demand.points.en).map((point, i) => (
                  <li key={i} className="text-[14px] text-emerald-100 leading-relaxed pl-5 relative font-medium">
                    <span className="absolute left-0 top-[8px] w-2 h-2 rounded-full bg-emerald-400" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Drones  */}
      <section className="relative w-full py-[32px] px-5 overflow-hidden bg-[#111]">
        {/* Background Image with Dark Overlay */}
        <div
          className="absolute inset-0 z-0"
          style={{
            // Placeholder for your agricultural field background image
            // backgroundImage: `url(${"whydrone"})`,
            backgroundColor: "#059669",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* Dark overlay for readability */}
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative z-10 max-w-[1200px] mx-auto">
          {/* Header Text & Button */}
          <div className="flex flex-col items-center text-center mb-10">
            <span className="text-[12px] md:text-[13px] font-extrabold tracking-[0.2em] text-green-400 uppercase mb-2">
              {hi ? "भविष्य की तकनीक" : "Future Technology"}
            </span>
            <h2 className="text-[36px] md:text-[44px] font-extrabold text-white tracking-tight mb-3">
              {hi ? "ड्रोन छिड़काव सेवाएं क्यों जरूरी हैं?" : "Why Are Drone Spray Services Important?"}
            </h2>
            <p className="text-[16px] md:text-[18px] text-gray-300 max-w-[800px] leading-relaxed mb-5">
              {hi
                ? "आधुनिक कृषि को आधुनिक समाधानों की आवश्यकता है। ड्रोन हमारे किसानों के लिए अभूतपूर्व दक्षता, लागत-बचत और पर्यावरणीय लाभ ला रहे हैं।"
                : "Modern agriculture requires modern solutions. Drones are bringing unprecedented efficiency, cost-savings, and environmental benefits to our farmers."}
            </p>
            {/* <button
              onClick={() =>
                document.getElementById("form")?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                })
              }
              className="bg-[#4ade80] hover:bg-[#34c759] text-gray-900 px-8 py-3.5 rounded-full font-bold text-[16px] transition-all shadow-[0_4px_15px_rgba(74,222,128,0.3)]"
            >
              {hi ? "अभी आवेदन करें" : "Apply Now"}
            </button> */}
          </div>

          {/* White Cards Grid */}
          <div className="max-w-[1050px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {droneFeatures.map((feature, idx) => {
              // Colors matching the reference image style
              const iconBgColors = [
                "bg-[#60a5fa]", // Light Blue
                "bg-[#fbbf24]", // Yellow
                "bg-[#f472b6]", // Pink
                "bg-[#34d399]", // Mint Green
              ];

              return (
                <div
                  key={feature.id}
                  className="bg-white rounded-[16px] p-4 hover:-translate-y-1 transition-transform duration-300 shadow-lg flex flex-col"
                >
                  {/* Icon Container */}
                  <div
                    className={`w-[40px] h-[40px] rounded-[10px] ${iconBgColors[idx % 4]} flex items-center justify-center mb-3 [&_svg]:!text-white [&_svg]:!w-5 [&_svg]:!h-5`}
                  >
                    {feature.icon}
                  </div>

                  {/* Text Content */}
                  <h3 className="text-[16px] md:text-[17px] font-bold text-gray-900 mb-1.5 tracking-tight leading-snug">
                    {hi ? feature.title.hi : feature.title.en}
                  </h3>
                  <p className="text-[13.5px] md:text-[14.5px] text-gray-500 leading-tight">
                    {hi ? feature.desc.hi : feature.desc.en}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* PARTNERING FOR SUCCESS */}
      <section className="bg-[#f8fafc] py-[24px] px-5">
        <div className="max-w-[1200px] mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-[28px] md:text-[34px] font-bold text-[#111827] mb-3 tracking-tight">
              {hi ? "डीएसके आपको क्या देगा?" : "What Will DSK Provide You?"}
            </h2>
            <p className="text-[15px] text-[#4b5563] max-w-[700px] mx-auto leading-relaxed">
              {hi
                ? "हम अपने भागीदारों की सफलता सुनिश्चित करने के लिए एंड-टू-एंड हैंडहोल्डिंग प्रदान करते हैं, आधुनिक कृषि तकनीक को एक अत्यधिक लाभदायक उद्यम में बदलते हैं।"
                : "We provide end-to-end handholding to ensure our partners succeed, turning modern agricultural technology into a highly profitable enterprise."}
            </p>
          </div>

          {/* Unified 3-Column Card */}
          <div className="flex flex-col lg:flex-row w-full bg-white rounded-[24px] overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100">
            {/* Column 1: DSK's Support (White Background) */}
            <div className="w-full lg:w-[33.33%] px-6 py-6 md:px-8 md:py-6 flex flex-col justify-center bg-white">
              <div>
                <h3 className="text-[22px] font-bold text-gray-900 mb-2 tracking-tight">
                  {hi ? "पूरा व्यवसाय सहयोग" : "Complete Business Support"}
                </h3>
                <p className="text-[13px] text-gray-500 mb-5 leading-relaxed max-w-[280px]">
                  {hi
                    ? "आपकी सफलता सुनिश्चित करने के लिए हमारा पूरा सहयोग।"
                    : "Our complete support to ensure your success."}
                </p>
              </div>

              <div>
                <div className="flex flex-wrap gap-2.5">
                  {[
                    { en: "Agriculture Drone", hi: "कृषि ड्रोन" },
                    { en: "Batteries & Charger", hi: "बैटरी और चार्जर" },
                    { en: "Spare Parts", hi: "अतिरिक्त पुर्जे" },
                    { en: "Training", hi: "प्रशिक्षण" },
                    { en: "Certificate", hi: "प्रमाण पत्र" },
                    { en: "Tech Support", hi: "तकनीकी सहायता" },
                    { en: "Branding", hi: "पहचान निर्माण" },
                    { en: "Marketing", hi: "प्रचार सामग्री" },
                    { en: "Loan Assist", hi: "ऋण सहायता" },
                    { en: "Guidance", hi: "व्यवसाय मार्गदर्शन" }
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5 hover:bg-emerald-50 hover:border-emerald-200 transition-colors">
                      <svg className="w-3.5 h-3.5 text-emerald-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span className="text-[12.5px] text-gray-700 font-semibold whitespace-nowrap">
                        {hi ? item.hi : item.en}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Column 2: Image */}
            <div className="w-full lg:w-[33.33%] relative min-h-[300px] lg:min-h-auto flex-shrink-0 overflow-hidden">
              <img
                src={partnering}
                alt="Farmer in Field"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>

            {/* Column 3: Ways to Earn (Dark Green Background) */}
            <div className="w-full lg:w-[33.34%] bg-[#064e3b] px-6 py-6 md:px-8 md:py-6 flex flex-col text-white flex-shrink-0">
              <div>
                <h3 className="text-[22px] font-bold text-white mb-2 tracking-tight">
                  {hi ? "कमाई के तरीके" : "Ways to Earn"}
                </h3>
                <p className="text-[13px] text-white/70 mb-3 leading-relaxed max-w-[280px]">
                  {hi
                    ? "ड्रोन दक्षता के साथ अपनी आय के कई स्रोत बनाएं।"
                    : "Create multiple streams of income with drone efficiency."}
                </p>
              </div>

              <div className="flex-1 flex flex-col justify-top">
                <ul className="flex flex-col gap-3">
                  {[
                    { en: "Field spraying services", hi: "खेतों में छिड़काव सेवाएं" },
                    { en: "Fertilizer and pesticide spraying", hi: "खाद और दवाई छिड़काव" },
                    // { en: "Crop monitoring", hi: "फसल निगरानी" },
                    // { en: "Farm surveys", hi: "खेत सर्वेक्षण" },
                    // { en: "Photography", hi: "फोटोग्राफी" },
                    // { en: "Event video recording", hi: "कार्यक्रम वीडियो रिकॉर्डिंग" },
                    { en: "Drone rental services", hi: "ड्रोन किराये पर देना" }
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="w-4 h-4 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-emerald-500/30">
                        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400"></div>
                      </div>
                      <span className="text-[13.5px] text-white/95 font-medium leading-tight">
                        {hi ? item.hi : item.en}
                      </span>
                    </li>
                  ))}
                </ul>

                <div className="mt-4 px-4 py-3.5 rounded-[16px] bg-white/10 backdrop-blur-md border border-white/20 shadow-[0_8px_32px_rgba(0,0,0,0.15)] relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none"></div>
                  <div className="text-[11px] font-bold text-emerald-300 uppercase tracking-wider mb-1 relative z-10">
                    {hi ? "संभावित कमाई" : "Expected Income"}
                  </div>
                  <div className="text-[20px] sm:text-[22px] font-extrabold text-white leading-tight relative z-10">
                    {hi ? "₹50,000 से ₹1 लाख+" : "₹50,000 to ₹1 Lakh+"}
                  </div>
                  <div className="text-[12px] text-emerald-100/80 mt-0.5 relative z-10">
                    {hi ? "हर महीने" : "every month"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who can apply */}
      {/* <section className="bg-[#f9fafb] py-[12px] px-5 border-t border-gray-100">
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-8">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
              <div className="max-w-[600px]">
                <h2 className="text-[28px] md:text-[34px] font-bold text-gray-900 tracking-tight mb-3">
                  {hi ? "कौन आवेदन कर सकता है?" : "Who Can Apply?"}
                </h2>
                <p className="text-[15px] text-gray-500 leading-relaxed">
                  {hi
                    ? "यह देखने के लिए श्रेणियों की समीक्षा करें कि आप किस सब्सिडी स्तर के लिए योग्य हैं। सभी योग्य समूहों का पता लगाने के लिए क्षैतिज रूप से स्वाइप करें।"
                    : "Review the categories to see which subsidy tier you qualify for. Swipe horizontally to explore all eligible groups."}
                </p>
              </div>

              <div className="hidden sm:flex items-center gap-3 shrink-0">
                <button
                  onClick={scrollLeft}
                  className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:text-green-600 transition-colors shadow-sm"
                  aria-label="Scroll left"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  onClick={scrollRight}
                  className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:text-green-600 transition-colors shadow-sm"
                  aria-label="Scroll right"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>

            <div
              ref={scrollRef}
              className="flex overflow-x-auto gap-5 pb-6 hide-scrollbar snap-x snap-mandatory scroll-smooth"
            >
              {applicantTypes.filter(type => hi ? type.title.hi : type.title.en).map((type, idx) => {
                const greenShades = [
                  { bg: "bg-emerald-50", iconBg: "bg-emerald-100", text: "text-emerald-700", border: "border-emerald-200" },
                  { bg: "bg-teal-50", iconBg: "bg-teal-100", text: "text-teal-700", border: "border-teal-200" },
                  { bg: "bg-green-50", iconBg: "bg-green-100", text: "text-green-700", border: "border-green-200" },
                  { bg: "bg-lime-50", iconBg: "bg-lime-100", text: "text-lime-700", border: "border-lime-200" },
                ];
                const theme = greenShades[idx % greenShades.length];

                return (
                  <div key={type.id} className="min-w-[380px] md:min-w-[420px] snap-start flex flex-col gap-3">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-[0_2px_10px_rgb(0,0,0,0.02)] transition-shadow hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] flex flex-col h-full">
                      <div className="flex items-center gap-4 mb-4">
                        <div className={`w-12 h-12 rounded-xl ${theme.iconBg} ${theme.text} flex items-center justify-center flex-shrink-0 [&_svg]:!text-current`}>
                          {type.icon}
                        </div>
                        <h4 className="text-[17px] font-bold text-gray-900 leading-tight">
                          {hi ? type.title.hi : type.title.en}
                        </h4>
                      </div>
                      <p className="text-[13.5px] text-gray-500 leading-relaxed m-0">
                        {hi ? type.desc.hi : type.desc.en}
                      </p>
                    </div>


                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </section> */}

      {/* ========================================== */}
      {/* BASIC REQUIREMENTS SECTION                 */}
      {/* ========================================== */}
      {/* <section className="bg-[#0b2416] py-[32px] md:py-[40px] px-5 relative overflow-hidden">
        
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#10b981] rounded-full blur-[120px] opacity-10 pointer-events-none"></div>

        <div className="max-w-[1200px] mx-auto relative z-10">
          <div className="mb-8 text-center flex flex-col items-center">
            <h2 className="text-[28px] md:text-[34px] font-bold text-white tracking-tight mb-2 text-center">
              {hi ? "जरूरी योग्यता" : "Required Eligibility"}
            </h2>
            <p className="text-[14px] md:text-[15px] text-white/70 leading-relaxed max-w-[600px] text-center">
              {hi
                ? "आपकी श्रेणी की परवाह किए बिना, सुनिश्चित करें कि आप इन बुनियादी मानदंडों को पूरा करते हैं और आवेदन प्रक्रिया शुरू करने से पहले आपके पास आवश्यक दस्तावेज हैं।"
                : "Regardless of your category, ensure you meet these fundamental criteria and have the necessary documents before initiating the application process."}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
            {requirements.map((req, idx) => {
              const cardThemes = [
                { bg: "bg-emerald-50/95", border: "border-emerald-200", iconText: "text-emerald-700", iconBg: "bg-emerald-100" },
                { bg: "bg-teal-50/95", border: "border-teal-200", iconText: "text-teal-700", iconBg: "bg-teal-100" },
                { bg: "bg-green-50/95", border: "border-green-200", iconText: "text-green-700", iconBg: "bg-green-100" },
                { bg: "bg-lime-50/95", border: "border-lime-200", iconText: "text-lime-700", iconBg: "bg-lime-100" },
                { bg: "bg-cyan-50/95", border: "border-cyan-200", iconText: "text-cyan-700", iconBg: "bg-cyan-100" },
              ];
              const theme = cardThemes[idx % cardThemes.length];

              return (
                <div
                  key={req.id}
                  className={`${theme.bg} backdrop-blur-md border ${theme.border} rounded-2xl p-4 md:p-5 flex gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(0,0,0,0.3)]`}
                >
      
                  <div className={`w-12 h-12 rounded-xl ${theme.iconBg} ${theme.iconText} flex items-center justify-center flex-shrink-0 shadow-sm [&_svg]:!text-current`}>
                    {req.icon}
                  </div>

                  <div>
                    <div className={`text-[10px] font-bold ${theme.iconText} uppercase tracking-wider mb-1`}>
                      {hi ? req.label.hi : req.label.en}
                    </div>
                    <h5 className="text-[16px] font-bold text-gray-900 mb-1 leading-tight">
                      {hi ? req.title.hi : req.title.en}
                    </h5>
                    <p className="text-[13px] text-gray-700 leading-relaxed m-0">
                      {hi ? req.desc.hi : req.desc.en}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section> */}

      {/* Application process */}
      <section className="bg-white py-[40px] md:py-[60px] px-5">
        <div className="max-w-[1150px] mx-auto">

          {/* Centered Headers */}
          <div className="mb-12 text-center flex flex-col items-center">
            <h2 className="text-[32px] md:text-[38px] font-bold text-gray-900 tracking-tight mb-4">
              {hi ? "उद्यमी बनने का तरीका" : "How to Become an Entrepreneur"}
            </h2>
            <p className="text-[15px] md:text-[16px] text-gray-500 leading-relaxed max-w-[650px] mx-auto">
              {hi
                ? "आपके कृषि ड्रोन को प्राप्त करने के लिए एक सरल, पारदर्शी और निर्देशित यात्रा। हम जटिलताओं को संभालते हैं ताकि आप खेती पर ध्यान केंद्रित कर सकें।"
                : "A simple, transparent, and guided journey to acquiring your agricultural drone. We handle the complexities so you can focus on farming."}
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-stretch">
            {/* ========================================== */}
            {/* LEFT COLUMN: Image with Glass Overlay      */}
            {/* ========================================== */}
            <div className="w-full lg:w-[45%] relative rounded-[24px] overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.06)] min-h-[450px] lg:min-h-0 flex-shrink-0">
              {/* Main Image Placeholder (Vertical/Portrait) */}
              <img
                src={farmerfield}
                alt="Farmer in Field"
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Subtle dark gradient at the bottom for text readability */}
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/60 to-transparent"></div>

              {/* Glassmorphism Floating Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/20 backdrop-blur-md border border-white/30 rounded-2xl p-4 flex items-center gap-4 shadow-xl">
                {/* Green Check Icon */}
                <div className="w-10 h-10 rounded-full bg-[#10b981] flex items-center justify-center flex-shrink-0 shadow-md">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.5"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="text-[15px] font-bold text-white mb-0.5 tracking-wide">
                    {hi ? "निर्देशित प्रक्रिया" : "Guided Process"}
                  </h4>
                  <p className="text-[12px] text-white/90">
                    {hi
                      ? "हम हर कदम पर आपकी सहायता करते हैं"
                      : "We assist you at every step"}
                  </p>
                </div>
              </div>
            </div>

            {/* ========================================== */}
            {/* RIGHT COLUMN: Interactive Timeline Card    */}
            {/* ========================================== */}
            <div className="w-full lg:w-[55%] flex flex-col">
              {/* Interactive Timeline/Checklist Card */}
              <div className="bg-white border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.06)] rounded-[24px] p-8 md:p-10 h-full flex flex-col justify-center">
                <div className="flex flex-col">
                  {applicationSteps.map((step, index) => {
                    const isActive = index === activeStep;

                    return (
                      <div
                        key={step.id}
                        className="relative flex gap-6 mb-8 last:mb-0 cursor-pointer transition-all duration-300"
                        onMouseEnter={() => setActiveStep(index)}
                      >
                        {/* Vertical Connecting Line (Except for last item) */}
                        {index !== applicationSteps.length - 1 && (
                          <div
                            className={`absolute left-[19px] top-[40px] bottom-[-32px] w-[2px] transition-colors duration-300 ${isActive ? 'bg-[#10b981]' : 'bg-gray-100'}`}
                            aria-hidden="true"
                          />
                        )}

                        {/* Step Number Circle / Checkmark */}
                        <div className={`relative z-10 w-10 h-10 rounded-full border-[2px] text-[15px] font-bold flex items-center justify-center flex-shrink-0 transition-all duration-300 shadow-sm overflow-hidden ${isActive ? 'bg-[#10b981] border-[#10b981] text-white' : 'bg-white border-gray-200 text-gray-400'}`}>
                          <span className={`block transition-all duration-300 ${isActive ? 'hidden' : 'block'}`}>{step.id}</span>
                          <svg className={`w-5 h-5 text-white transition-all duration-300 ${isActive ? 'block' : 'hidden'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>

                        {/* Step Content */}
                        <div className={`pt-1.5 pb-2 flex-1 rounded-xl px-4 py-3 -mt-3 -ml-2 transition-colors duration-300 ${isActive ? 'bg-[#f0fdf4]' : ''}`}>
                          <h4 className={`text-[16px] font-bold mb-1.5 transition-colors duration-300 ${isActive ? 'text-[#065f46]' : 'text-gray-700'}`}>
                            {hi ? step.title.hi : step.title.en}
                          </h4>
                          <p className={`text-[13.5px] leading-relaxed transition-colors duration-300 ${isActive ? 'text-[#064e3b]' : 'text-gray-500'}`}>
                            {hi ? step.desc.hi : step.desc.en}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* PANCHAYAT */}
      {/* <section className="bg-white py-[72px] px-5">
        <div className="max-w-[1100px] mx-auto">
          <SectionTag>{hi ? "अभी शुरू करें" : "Active Now"}</SectionTag>
          <SectionHeading>
            {hi ? (
              <>
                421 पंचायतों में{" "}
                <span className="text-green-800">आवेदन शुरू</span>
              </>
            ) : (
              <>
                Applications Started in{" "}
                <span className="text-green-800">421 Panchayats</span>
              </>
            )}
          </SectionHeading>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-11">
            {hi
              ? "देशभर के गांवों में ड्रोन व्यवसाय तेजी से बढ़ रहा है। आपकी पंचायत अगली हो सकती है।"
              : "Drone businesses are growing rapidly in villages across the country. Your Panchayat could be next."}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {panchayats.map((p, i) => (
              <div
                key={i}
                className={`border rounded-[18px] p-5 text-center ${p.total ? "bg-green-50 border-green-200" : "bg-gray-50 border-gray-200"}`}
              >
                <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  {hi ? p.name.hi : p.name.en}
                </div>
                <div
                  className={`text-[36px] font-bold leading-none ${p.total ? "text-green-800" : "text-gray-900"}`}
                >
                  {p.num}
                </div>
                <div className="text-[12px] text-gray-500 mt-1.5">
                  {hi ? p.desc.hi : p.desc.en}
                </div>
              </div>
            ))}
          </div>
          <div className="text-center">
            <a
              href="#form"
              className="inline-flex items-center gap-2 px-6 py-[11px] rounded-xl text-sm font-semibold text-white bg-green-800 border border-green-800 no-underline transition hover:bg-green-700"
            >
              {hi ? "अपनी जगह सुरक्षित करें" : "Secure Your Seat"}
            </a>
          </div>
        </div>
      </section> */}

      {/* PROBLEMS */}
      {/* <section className="bg-gray-50 border-t border-b border-gray-200 py-[72px] px-5">
        <div className="max-w-[1100px] mx-auto">
          <SectionTag>
            {hi ? "गांव की समस्याएं" : "Village Problems"}
          </SectionTag>
          <SectionHeading>
            {hi ? (
              <>
                "मेहनत बढ़ रही है…{" "}
                <span className="text-green-800">लेकिन कमाई नहीं।"</span>
              </>
            ) : (
              <>
                "Hard work is increasing…{" "}
                <span className="text-green-800">but income is not."</span>
              </>
            )}
          </SectionHeading>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-11">
            {hi
              ? "आज गांव की सबसे बड़ी समस्या है — काम और अवसरों की कमी।"
              : "Today the biggest problem in villages is the lack of work and opportunities."}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {problems.map((p, i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-[18px] p-6"
              >
                <span className="inline-block text-[11px] font-semibold uppercase tracking-wide text-red-700 bg-red-50 rounded-md px-2 py-0.5 mb-3">
                  {hi ? p.label.hi : p.label.en}
                </span>
                <h4 className="text-[15px] font-semibold text-gray-900 mb-2">
                  {hi ? p.title.hi : p.title.en}
                </h4>
                <p className="text-[13px] text-gray-500 leading-relaxed mb-2.5">
                  {hi ? p.body.hi : p.body.en}
                </p>
                {p.example && (
                  <p className="text-[12px] text-gray-400 border-t border-gray-200 pt-2.5 italic mb-2.5">
                    {hi ? p.example.hi : p.example.en}
                  </p>
                )}
                <p className="text-[12px] text-green-800 font-semibold bg-green-50 rounded-md px-2.5 py-1.5">
                  {hi ? p.solution.hi : p.solution.en}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* SUCCESS STORIES */}
      {/* <section className="bg-white py-[72px] px-5">
        <div className="max-w-[1100px] mx-auto">
          <SectionTag>
            {hi ? "सफलता की कहानियां" : "Success Stories"}
          </SectionTag>
          <SectionHeading>
            {hi ? (
              <>
                गांव के लोग कैसे{" "}
                <span className="text-green-800">बदल रहे हैं?</span>
              </>
            ) : (
              <>
                How Are Village People{" "}
                <span className="text-green-800">Changing?</span>
              </>
            )}
          </SectionHeading>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-11">
            {hi
              ? '"इस बदलाव का हिस्सा आपका गांव भी बन सकता है।"'
              : '"Your village can also become part of this change."'}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {stories.map((s, i) => (
              <div
                key={i}
                className="bg-gray-50 border border-gray-200 rounded-[18px] p-6"
              >
                <div className="text-sm font-bold text-gray-900 pb-3 mb-3.5 border-b border-gray-200">
                  {hi ? s.name.hi : s.name.en}
                </div>
                <p className="text-[13px] text-gray-500 pl-3.5 relative leading-relaxed mb-2">
                  <span className="absolute left-0 top-2 w-1.5 h-1.5 rounded-full bg-red-600" />
                  {hi ? s.before.hi : s.before.en}
                </p>
                <p className="text-[13px] text-gray-500 pl-3.5 relative leading-relaxed mb-3">
                  <span className="absolute left-0 top-2 w-1.5 h-1.5 rounded-full bg-green-800" />
                  {hi ? s.after.hi : s.after.en}
                </p>
                <span className="inline-block text-[12px] font-semibold text-green-800 bg-green-50 rounded-md px-2.5 py-1.5">
                  {hi ? s.today.hi : s.today.en}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* WHY DRONE */}
      {/* <section className="bg-gray-50 border-t border-b border-gray-200 py-[72px] px-5">
        <div className="max-w-[1100px] mx-auto">
          <div className="text-center mb-1">
            <SectionTag>{hi ? "ड्रोन क्यों?" : "Why Drone?"}</SectionTag>
          </div>
          <SectionHeading center>
            {hi ? (
              <>
                ड्रोन छिड़काव{" "}
                <span className="text-green-800">क्यों जरूरी है?</span>
              </>
            ) : (
              <>
                Why Are Drone Spray{" "}
                <span className="text-green-800">Services Important?</span>
              </>
            )}
          </SectionHeading>
          <p className="text-[15px] text-gray-500 text-center max-w-[580px] mx-auto leading-relaxed mb-11">
            {hi
              ? "नई तकनीक से नई कमाई शुरू करें — खेती में क्रांति लाएं।"
              : "Start a new income with new technology — bring a revolution in farming."}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {whyDrone.map((w, i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-[18px] p-5 text-center"
              >
                <h4 className="text-sm font-semibold text-gray-900 mb-2">
                  {hi ? w.title.hi : w.title.en}
                </h4>
                <p className="text-[12px] text-gray-500 leading-relaxed">
                  {hi ? w.desc.hi : w.desc.en}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section> */}



      {/* WHO CAN APPLY */}
      {/* <section className="bg-gray-50 border-t border-b border-gray-200 py-[72px] px-5">
        <div className="max-w-[1100px] mx-auto">
          <SectionTag>
            {hi ? "कौन आवेदन कर सकता है?" : "Who Can Apply?"}
          </SectionTag>
          <SectionHeading>
            {hi ? (
              <>
                आवेदन <span className="text-green-800">करने के लिए योग्य</span>
              </>
            ) : (
              <>
                Eligible <span className="text-green-800">to Apply</span>
              </>
            )}
          </SectionHeading>
          <p className="text-[15px] text-gray-500 max-w-[580px] leading-relaxed mb-11">
            {hi
              ? "गांव या छोटे कस्बे में रहने वाले — किसी भी पृष्ठभूमि से।"
              : "Residents of villages or small towns — from any background."}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-8">
            {whoCanApply.map((w, i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-xl px-3 py-4 text-center text-[12px] font-medium text-gray-700 transition cursor-default hover:bg-green-50 hover:border-green-200 hover:text-green-800"
              >
                {hi ? w.hi : w.en}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {eligibility.map((e, i) => (
              <div
                key={i}
                className="bg-white border border-gray-200 rounded-xl px-3.5 py-4"
              >
                <div className="text-[15px] font-bold text-gray-900 mb-0.5">
                  {hi ? e.val.hi : e.val.en}
                </div>
                <div className="text-[11px] text-gray-500 font-medium uppercase tracking-[0.3px]">
                  {hi ? e.lbl.hi : e.lbl.en}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* STEPS */}
      {/* <section className="bg-white py-[72px] px-5">
        <div className="max-w-[1100px] mx-auto">
          <div className="text-center mb-1">
            <SectionTag>{hi ? "प्रक्रिया" : "Process"}</SectionTag>
          </div>
          <SectionHeading center>
            {hi ? (
              <>
                उद्यमी बनने का <span className="text-green-800">तरीका</span>
              </>
            ) : (
              <>
                How to Become{" "}
                <span className="text-green-800">an Entrepreneur</span>
              </>
            )}
          </SectionHeading>
          <p className="text-[15px] text-gray-500 text-center max-w-[580px] mx-auto leading-relaxed mb-11">
            {hi
              ? "कम दस्तावेज, तेज प्रक्रिया, पूरा सहयोग।"
              : "Less documentation, fast process, complete support."}
          </p>
          <div className="max-w-[720px] mx-auto">
            {steps.map((step, i) => (
              <div key={i} className="flex gap-5 mb-2 pb-2 relative">
                {i < steps.length - 1 && (
                  <span
                    className="absolute left-[19px] top-[42px] w-px bottom-0 bg-gray-200"
                    style={{ zIndex: 0 }}
                  />
                )}
                <div className="w-10 h-10 rounded-full bg-green-50 border border-green-200 flex items-center justify-center text-[13px] font-bold text-green-800 flex-shrink-0 relative z-10">
                  {step.num}
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-xl px-[18px] py-3.5 flex-1 mb-4">
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">
                    {hi ? step.title.hi : step.title.en}
                  </h4>
                  <p className="text-[13px] text-gray-500">
                    {hi ? step.desc.hi : step.desc.en}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
    </>
  );
}
